import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
// import { faqs } from "./acceleratedCashbackData";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ctaImage from '../../pages/mystery-box/images/bg-top.png';
import Mystery from '../../pages/mystery-box/images/image.png';
import Heading from '../../pages/mystery-box/images/top-heading.png';
import Mbheading from '../../pages/mystery-box/images/mbheading.png';
import UnlockHeading from '../../pages/mystery-box/images/unlock-heading.png'
import Lock from '../../pages/mystery-box/images/lock.png';
import RegisterButton from '../../pages/mystery-box/images/cta1.png';
import StickyRegisterButton from '../../pages/mystery-box/images/sticky-reg.png';
import Unlock from '../../pages/mystery-box/images/unlock.png';
import Openimage from '../../pages/mystery-box/images/open.png';
import Bg from '../../pages/mystery-box/images/state-bg.png';
import ReactHtmlParser from 'html-react-parser';
import RevealButton from '../../pages/mystery-box/images/reaveal.png';
import { useNavigate } from 'react-router-dom';
import Alert from './component/registerAlert';
import staticBg from './images/bgGif.gif'
import ErrorAlert from './component/errorAlert';
import NewAlert from './component/newAlert';


const faqs = [
  {
    question: "What is the Mystery Gift Box?",
    answer: "The Mystery Gift Box is a special offer where you can unlock a Bonus Cashback of up to ₹500 on your next transaction till 30th April 2025."
  },
  {
    question: "How do I unlock & claim my Mystery Bonus? ",
    answer:  "To unlock the Mystery Bonus, you must transact with an eligible retailer that offers Cashback / Rewards.  When you complete the transaction, wait 24-48 hours after it is tracked and reflected in “My Earnings” section on the CashKaro app. Once updated, your Mystery Bonus will unlock and can be claimed by tapping the gift box on this offer landing page. "
  },
  {
    question: "Can I unlock the Bonus on any transaction? ",
    answer: "This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback/ Rewards are unavailable. Any other successful transaction within the offer period will make you eligible to unlock the Bonus."
  },
  {
    question: "Can I claim the Bonus more than once in a month? ",
    answer: "No, each user is eligible for only one Mystery Bonus per month."
  },
  {
    question: "What happens if I cancel my transaction after unlocking the Bonus? ",
    answer: "If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed. However, you can still make another valid transaction within the offer period to confirm and claim your Bonus. "  
  },
  {
    question: "How long does it take for my Bonus to be credited? ",
    answer: "The Bonus amount will be added to your CashKaro account within 24 – 48 hours of claiming. It will appear in Pending state in “My Earnings” section on your CashKaro app/ website. The Bonus will only be Confirmed and credited after the transaction linked to it is confirmed and validated or by 15th June 2025 (whichever is earlier)."
  },
  {
    question: "Can my Bonus be changed or canceled? ",
    answer: "Once the Bonus is unlocked and claimed, it cannot be altered. However, if your qualifying transaction is canceled or invalid, and no other valid transaction is made during the offer period, the Bonus will be cancelled."
  }
];
const Terms = [
  {
    question: "Eligibility Criteria",
    answer: `<ul>
    <li>This offer is valid only for users who have received official communication from CashKaro about it.</li>
    <li>Each user is eligible for only one Mystery Bonus per month.</li>
  </ul>`},
  {
    question: "Bonus Unlock & Tracking Process",
    answer: `<ul>
    <li>To unlock the Mystery Bonus, the user must transact with an eligible retailer that offers Cashback / Rewards.</li>
    <li>Upon completing the transaction, users must wait 24-48 hours after it is added and reflected in the "My Earnings" section before their Mystery Bonus unlocks and can be claimed.</li>
    <li>The unlocked Mystery Bonus will be available for claiming on the offer landing page.</li>
    <li>The Bonus amount will be added to the user’s CashKaro account within 24 - 48 hours after the claim.</li>
    <li>It will be reflected in pending state in the “My Earnings” section of the user's account on the CashKaro app or website.</li>
    <li>The Bonus amount will be confirmed and credited only after the transaction linked to it is confirmed and validated or by 15th June 2025 (whichever is earlier).</li>
    <li>This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback is unavailable.</li>

  </ul>`},
  {
    question: "Bonus Amount Allocation",
    answer: `<ul>
    <li>The Bonus is randomly assigned and can be up to ₹500. The assigned amount is final and cannot be changed or influenced.</li>
    <li>Only transactions made within the offer period will be eligible to unlock the Mystery Bonus.</li>
  </ul>`},
  {
    question: "Disqualification Criteria",
    answer: `<ul>
    <li>If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed.</li>
    <li>However, the user can still complete another valid transaction within the offer period to confirm and claim their Bonus.</li>
    <li>CashKaro reserves the right to revoke the Bonus if fraudulent activity, misuse, or policy violations are detected.</li>
  </ul>`},
  {
    question: "Modification & Termination",
    answer: `<ul>
    <li>Changes to the terms, eligibility, or Bonus structure will be communicated at CashKaro’s discretion.</li>
  </ul>`},
  {
    question: "General Terms",
    answer: `<ul>
    <li>Participation in this offer constitutes acceptance of these terms and conditions. CashKaro’s decision regarding all aspects of the offer will be final and binding.</li>
  </ul>`},
];

export default function MysteryBoxApril() {

  const [alertOpen, setAlertOpen] = useState(false);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(0);
  const [Reveal, setReveal] = useState(false);
  const [registered,setRegistered] = useState(false)
  const [mbOpen,setMbOpen] = useState(localStorage.getItem('mb_open_apr') || 0)
  const navigate = useNavigate();
  const [isPastCta1,setIsPastCta1] = useState(false)
  const cta1Ref = useRef(null);
  const [error,setError] = useState(false)
  const [daysLeft,setDaysLeft] = useState([])
  const [newError,setNewError] = useState(false)

  function daysUntilMarch31() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const march31 = new Date(currentYear, 3, 30); // March is month 2 in JavaScript (0-indexed)

    // Check if March 31st has already passed for the current year
    if (today > march31) {
        march31.setFullYear(currentYear + 1); // Set to March 31 of the next year
    }

    // Calculate the difference in milliseconds
    const diff = march31 - today;

    // Convert milliseconds to days
    return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1
}

useEffect(()=>{
  let days = daysUntilMarch31().toString()
  days = days.split('')
  if(days.length < 2){

    days.unshift(0)
  }
  console.log(days)
  setDaysLeft(days)
},[])

  

  const handleImageClick =  async () => {

    if(transaction > 0){
      setReveal(true);
      localStorage.setItem('mb_open_apr',1)
  try {
    const params = new URLSearchParams(window.location.search);
        let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid')
    let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/updatedata_mb_apr`,{
      method: 'POST',
      headers: { 
          'Content-Type': 'application/json'
      },
      body:JSON.stringify({
        "ck_id": `${ck_id}`,
        "claim": 1
      })
      
  })
  response=await response.json()
  console.log(response)
  if(response?.message){
    navigate('/mystery-box-april/congrats',{replace:true});
  }
  } catch (error) {
    console.log(error.message)
  }
    }
    
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(()=>{
    checkFunction()
  },[])



  let checkFunction = async () => {
    let ck_id_check = localStorage.getItem('mb_ck_id_apr')
 
    try {
      if(ck_id_check){
        setRegistered(true)
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_apr?ck_id=${ck_id_check}`)
        response = await response.json()
        console.log(response.user_data)
        setTransaction(response?.user_data?.transactions_tag)
        localStorage.setItem('mb_bonus_apr',response?.user_data?.bonus)
        localStorage.setItem('mb_bonus_added_apr',response?.user_data?.bonus_added)
        localStorage.setItem('mb_open_apr',response?.user_data?.claim)
        if(response?.user_data?.claim == 1){
          navigate('/mystery-box-april/bonus',{replace:true})
        }
       
      }
      
    } catch (error) {
      console.log(error.message)
    }
    if(mbOpen == 1){
      navigate('/mystery-box-april/bonus',{replace:true})
    }
  }
  

  const handleButtonClick = () => {
    // Navigate to the NewPage component
    navigate('/mystery-box-april/congrats',{replace:true});
  };
  const showAlert = async () => {
    console.log('hello')
    // setAlertOpen(true);
    try {
      const params = new URLSearchParams(window.location.search);
      let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid')
      console.log(ck_id)

      setNewError(true)
     
    } catch (error) {
      console.log(error.message)
    }

  };

  const closeAlert = () => {
    setAlertOpen(false);
  };
  // if (Reveal) {
  //   return (
  //     <Grid item xs={12} sm={12} md={4} lg={4}
  //       sx={{
  //         backgroundImage: `url(${Bg})`
  //       }}>
  //       <Box sx={{
  //         position: 'relative', width: '100%',  overflow: 'hidden',
  //       }}>
  //         {/* Video Background */}
  //         <video
  //           autoPlay
  //           loop
  //           muted
  //           playsInline
  //           style={{
  //             position: 'absolute',
  //             top: 0,
  //             left: 0,
  //             width: '100%',
  //             height: '100%',
  //             objectFit: 'cover',
  //           }}
  //         >
  //           <source src="https://d2sriifpjiqv0p.cloudfront.net/Loop%20Gift.mp4" type="video/mp4" />
  //           Your browser does not support the video tag.
  //         </video>
  //         <Box
  //           sx={{
  //             backgroundImage: `url(${ctaImage})`,
  //             width: '100%',
  //             height: '100%',
  //             position: 'absolute',
  //             backgroundSize: 'cover',
  //             backgroundRepeat: 'no-repeat',
  //             backgroundPosition: 'center',
  //             top: 0,
  //             left: 0,
  //             right: 0
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: 'flex',
  //               justifyContent: 'center',
  //               background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
  //               width: '100%',
  //               position: 'fixed',
  //               bottom: '0', // This fixes the element to the bottom of the screen
  //               zIndex: '9999999',
  //               // alignItems: 'center', // Uncomment if vertical alignment is needed
  //             }}
  //           >
  //             <img
  //               src={RevealButton}
  //               alt="RevealButton"
  //               style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
  //               onClick={handleButtonClick}
  //             />
  //           </div>

  //         </Box>

  //         {/* Overlay Content */}
  //       </Box>

  //       <Box sx={{ background: '#1c4563', paddingX: '18px' }}>
  //         <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '5px' }}>FAQs</Typography>
  //         {faqs.map((faq, i) => (
  //           <Box
  //             sx={{
  //               marginBottom: "16px",
  //               padding: "2px",
  //               background:
  //                 "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
  //               borderRadius: "14px",
  //             }}
  //           >
  //             <Accordion
  //               sx={{
  //                 borderRadius: "14px !important",
  //                 background: "#355974",
  //                 color: "#fff",
  //                 fontSize: "14px",
  //                 fontWeight: 600,
  //                 fontFamily: 'DM Sans'
  //               }}
  //             >
  //               <AccordionSummary
  //                 expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
  //                 sx={{ color: '#FFEEC3', }}>
  //                 {faq?.question}
  //               </AccordionSummary>
  //               <AccordionDetails>{faq?.answer}</AccordionDetails>
  //             </Accordion>
  //           </Box>))}
  //       </Box>
  //       <Box sx={{ background: '#1c4563', paddingX: '18px' }} pb={16}>
  //         <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
  //         {Terms.map((Terms, i) => (
  //           <Box
  //             sx={{
  //               marginBottom: "16px",
  //               padding: "2px",
  //               background:
  //                 "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
  //               borderRadius: "14px",
  //             }}
  //           >
  //             <Accordion
  //               sx={{
  //                 borderRadius: "14px !important",
  //                 background: "#355974",
  //                 color: "#fff",
  //                 fontSize: "14px",
  //                 fontWeight: 600,
  //                 fontFamily: 'DM Sans'
  //               }}
  //             >
  //               <AccordionSummary
  //                 expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
  //                 sx={{ color: '#FFEEC3', }}>
  //                 {Terms?.question}
  //               </AccordionSummary>
  //               <AccordionDetails>{Terms?.answer}</AccordionDetails>
  //             </Accordion>
  //           </Box>))}
  //       </Box>
  //       {/* <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} /> */}
  //     </Grid>
  //   );
  // }
  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      {transaction < 1 ? (
        <Grid item xs={12} sm={12} md={4} lg={4}
          sx={{
            backgroundImage: `url(${Bg})`
          }}>
          <Box sx={{
            position: 'relative', width: '100%', height: '100vh', overflow: 'hidden',
          }}>
            {/* Video Background */}
             {/* <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
              controls = {false}
            >
              <source src="https://d2sriifpjiqv0p.cloudfront.net/Loop%20Gift.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>  */}
            <img src={staticBg}  style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }} />
            <Box
              sx={{
                backgroundImage: `url(${ctaImage})`,
                width: '100%',
                height: '100%',
                position: 'absolute',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                top: 0,
                left: 0,
                right: 0
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px' }}>
                <img src={Mystery} alt="Mystery" style={{ width: '212px' }} />
              </div>
              <div style={{ display:registered ? 'none' : 'flex', justifyContent: 'center', paddingTop: '12px' }}>
                <img src={Heading} alt="heading" style={{ width: '100%' }} />
              </div>
              <div style={{ display: registered ? 'flex':'none', justifyContent: 'center', paddingTop: '12px' }}>
                <img src={UnlockHeading} alt="heading" style={{ width: '100%' }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px', marginTop: '43%' }}>
                <img src={Lock} alt="Lock" style={{ width: '96px', height: '96px' }} />
              </div>
            {/* {daysLeft.length > 0 &&  <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px', marginTop: '28%' }}>
                <Typography sx={{ position: 'relative', zIndex: 1, color: '#fff', fontWeight: '700', fontSize: '14px', fontFamily: "DM Sans", }}>
                  OFFER VALID FOR <span style={{ background: '#fff', padding: '2px 7px', borderRadius: '4px', color: '#000', fontFamily: 'Helvetica', color: '#358EB8', fontWeight: '700', fontSize: '20px' }}>{daysLeft[0]}</span>
                  <span style={{ marginLeft: '3px', background: '#fff', padding: '2px 7px', borderRadius: '4px', color: '#000', fontFamily: 'Helvetica', color: '#358EB8', fontWeight: '700', fontSize: '20px' }}>{daysLeft[1]}</span> MORE DAYS
                </Typography>
              </div>} */}
              <div ref={cta1Ref} style={{
                display: 'flex',
                justifyContent: 'center',
                // marginTop: '-3%',
                background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
                width: '100%',
                position: 'fixed',
                zIndex: '9999999',
                bottom:0,
                // alignItems: 'center', // Ensures vertical alignment if needed
              }}>
                {!registered ? (
                  <img
                    src={RegisterButton}
                    alt="RegisterButton"
                    style={{ width: '100%',visibility:error? 'hidden' : 'visible'}}
                    onClick={showAlert}
                  />
                ) : transaction > 0 ? (     <img
                  src={RevealButton}
                  alt="RevealButton"
                  style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
                  onClick={handleButtonClick}
                />) : (
            <a href='cashkaro://home'>
                    <img
                    src={Unlock}
                    alt="Unlock"
                    style={{ width: '100%' }}
                    
                  // onClick={showAlert}
                  />
            </a>
                )}            </div>
            </Box>

            {/* Overlay Content */}
          </Box>

          <Box sx={{ background: '#1c4563', paddingX: '18px' }}>
            <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '5px' }}>FAQs</Typography>
            {faqs.map((faq, i) => (
              <Box
                sx={{
                  marginBottom: "16px",
                  padding: "2px",
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                  borderRadius: "14px",
                }}
              >
                <Accordion
                  sx={{
                    borderRadius: "14px !important",
                    background: "#355974",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: 'DM Sans'
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{ color: '#FFEEC3', }}>
                    {faq?.question}
                  </AccordionSummary>
                  <AccordionDetails>{ReactHtmlParser(faq?.answer)}</AccordionDetails>
                </Accordion>
              </Box>))}
          </Box>
          <Box sx={{ background: '#1c4563', paddingX: '18px' }} pb={16}>
            <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
            {Terms.map((Terms, i) => (
              <Box
                sx={{
                  marginBottom: "16px",
                  padding: "2px",
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                  borderRadius: "14px",
                }}
              >
                <Accordion
                  sx={{
                    borderRadius: "14px !important",
                    background: "#355974",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: 'DM Sans'
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{ color: '#FFEEC3', }}>
                    {Terms?.question}
                  </AccordionSummary>
                  <AccordionDetails>{ReactHtmlParser(Terms?.answer)}</AccordionDetails>
                </Accordion>
              </Box>))}
          </Box>
          <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} />
          <ErrorAlert open={error} type="error" message={'You are not eligible for this campaign!'} setOpen={setError} />
          <NewAlert open={newError} setOpen={setNewError} message={'Registrations for this campaign have been closed'} />

        </Grid>
      ) : (




        // Else, show a thank you message (or any other content you want)
        <Grid item xs={12} sm={12} md={4} lg={4}
          sx={{
            backgroundImage: `url(${Bg})`
          }}>
          <Box sx={{
            position: 'relative', width: '100%', height: '100vh', overflow: 'hidden',
          }}>
            {/* Video Background */}
            {/* <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            >
              <source src="https://d2sriifpjiqv0p.cloudfront.net/Loop%20Gift.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}
                <img src={staticBg}  style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }} />
            <Box
              sx={{
                backgroundImage: `url(${ctaImage})`,
                width: '100%',
                height: '100%',
                position: 'absolute',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                top: 0,
                left: 0,
                right: 0
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px' }}>
                <img src={Mystery} alt="Mystery" style={{ width: '212px' }} />
              </div>
               <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px' }}>
                <img src={Mbheading} alt="heading" style={{ width: '100%' }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px', marginTop: '43%' }}>
                <div style={{ width: '96px', height: '96px' }}> </div>
              </div>
             {daysLeft.length > 0 &&  <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px', marginTop: '28%' }}>
                <Typography sx={{ position: 'relative', zIndex: 1, color: '#fff', fontWeight: '700', fontSize: '14px', fontFamily: "DM Sans", }}>
                  OFFER VALID FOR  <span style={{ background: '#fff', padding: '2px 7px', borderRadius: '4px', color: '#000', fontFamily: 'Helvetica', color: '#358EB8', fontWeight: '700', fontSize: '20px' }}>{daysLeft[0]}</span>
                  <span style={{ marginLeft: '3px', background: '#fff', padding: '2px 7px', borderRadius: '4px', color: '#000', fontFamily: 'Helvetica', color: '#358EB8', fontWeight: '700', fontSize: '20px' }}>{daysLeft[1]}</span> MORE DAYS
                </Typography>
              </div>}
              <div ref={cta1Ref} style={{
                display: 'flex',
                justifyContent: 'center',
                bottom: '0',
                background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
                width: '100%',
                position: 'fixed',
                zIndex: '9999999',
                // alignItems: 'center', // Ensures vertical alignment if needed
              }}>
                {Reveal ? (
                    <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
                      width: '100%',
                      position: 'fixed',
                      bottom: '0', // This fixes the element to the bottom of the screen
                      zIndex: '9999999',
                      // alignItems: 'center', // Uncomment if vertical alignment is needed
                    }}
                  >
                    <img
                      src={RevealButton}
                      alt="RevealButton"
                      style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
                      onClick={handleButtonClick}
                    />
                  </div>
                ) : (
                  <img
                    src={Openimage}
                    alt="Openimage"
                    style={{ width: '100%' }}
                    onClick={handleImageClick}
                  />
                )}
              </div>
            </Box>

            {/* Overlay Content */}
          </Box>

          <Box sx={{ background: '#1c4563', paddingX: '18px' }}>
            <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '5px' }}>FAQs</Typography>
            {faqs.map((faq, i) => (
              <Box
                sx={{
                  marginBottom: "16px",
                  padding: "2px",
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                  borderRadius: "14px",
                }}
              >
                <Accordion
                  sx={{
                    borderRadius: "14px !important",
                    background: "#355974",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: 'DM Sans'
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{ color: '#FFEEC3', }}>
                    {faq?.question}
                  </AccordionSummary>
                  <AccordionDetails>{faq?.answer}</AccordionDetails>
                </Accordion>
              </Box>))}
          </Box>
          <Box sx={{ background: '#1c4563', paddingX: '18px' }} pb={16}>
            <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
            {Terms.map((Terms, i) => (
              <Box
                sx={{
                  marginBottom: "16px",
                  padding: "2px",
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                  borderRadius: "14px",
                }}
              >
                <Accordion
                  sx={{
                    borderRadius: "14px !important",
                    background: "#355974",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: 'DM Sans'
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{ color: '#FFEEC3', }}>
                    {Terms?.question}
                  </AccordionSummary>
                  <AccordionDetails>{ReactHtmlParser(Terms?.answer)}</AccordionDetails>
                </Accordion>
              </Box>))}
          </Box>
          {/* <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} /> */}
        </Grid>
      )}
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
